<div class="form-inline">
  <div class="input-group">
    <input class="form-control"
           name="dateInput"
           placeholder="dd/mm/yyyy"
           [(ngModel)]="internalDate"
           ngbDatepicker
           #dp="ngbDatepicker"
           [required]="required"
           [readOnly]="isReadonly"
           [disabled]="isDisabled"
           [minDate]="ngbMinDate"
           [maxDate]="ngbMaxDate"
           (dateSelect)="onDateChange()" />
    <button class="btn btn-outline-secondary btn-auto"
            (click)="dp.toggle()"
            type="button"
            [disabled]="isDisabled || isReadonly">
      <i class="fal fa-calendar"></i>
    </button>
  </div>

  <div class="input-group ml-2">
    <span class="input-group-addon control-label">{{ 'SB_HH' | translate }}</span>
    <select class="form-control form-control-sm input-sm"
            [(ngModel)]="selectedHour"
            (ngModelChange)="onTimeChange()"
            [disabled]="isDisabled || timeSelectionDisabled">
      @for (h of hours; track h.id) {
        <option [value]="h.id" [disabled]="isHourDisabled(h.id)">{{ h.label }}</option>
      }
    </select>
  </div>

  <div class="input-group ml-2">
    <span class="input-group-addon control-label">{{ 'SB_MM' | translate }}</span>
    <select class="form-control form-control-sm input-sm"
            [(ngModel)]="selectedMinute"
            (ngModelChange)="onTimeChange()"
            [disabled]="isDisabled || timeSelectionDisabled">
      @for (m of minutes; track m.id) {
        <option [value]="m.id" [disabled]="isMinuteDisabled(m.id)">{{ m.label }}</option>
      }
    </select>
  </div>
</div>
